import { PopupParagraph, PopupTitle, PopupWrapper } from './InfoPopup.styles';

const InfoPopup = ({
	title,
	firstParagraph,
	secondParagraph,
	thirdParagraph,
}) => {
	return (
		<PopupWrapper className='your-score-info-popup'>
			<PopupTitle>{title}</PopupTitle>
			<PopupParagraph>{firstParagraph}</PopupParagraph>
			<PopupParagraph>{secondParagraph}</PopupParagraph>
			<PopupParagraph>{thirdParagraph}</PopupParagraph>
		</PopupWrapper>
	);
};

export default InfoPopup;